<template>
  <el-drawer title="添加" :visible.sync="drawer" size="50%" :before-close="handleClose">
    <div class="m-tabs-content">
      <el-form :model="addForm" :rules="rules" ref="addForm" label-width="80px">
        <el-form-item label="产品名称" prop="title">
          <el-input v-model="addForm.title" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="产品类目" prop="type">
          <el-select v-model.number="addForm.type" placeholder="请选择" size="mini">
            <el-option label="公司注册" :value="0"></el-option>
            <el-option label="代理记账" :value="1"></el-option>
            <el-option label="增值服务" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品规格">
          <el-tag
            :key="tag"
            v-for="tag in specifications"
            closable
            :disable-transitions="false"
            @close="handleTagClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="tagInputVisible"
            v-model="tagInputValue"
            ref="saveTagInput"
            size="mini"
            @keyup.enter.native="handleTagInputConfirm"
            @blur="handleTagInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="mini" @click="showTagInput">添加规格</el-button>
        </el-form-item>
        <el-form-item label="封面图片">
          <el-input v-model="addForm.image" placeholder="选择图片" prefix-icon="el-icon-picture-outline" size="mini" disabled>
            <el-button slot="append" type="primary" icon="el-icon-folder-opened" size="mini" @click="triggerFileInput">
              浏览
              <input type="file" ref="skuFileInput" id="skuFileInput" style="display: none" @change="handleFileChange" />
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="产品详情" class="ueditor">
          <vue-ueditor-wrap
            v-model="addForm.description"
            :config="myConfig"
          ></vue-ueditor-wrap>
        </el-form-item>
        <el-form-item label="上架">
          <el-radio-group v-model="addForm.on_sale" size="mini">
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="0" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-divider content-position="left">SKU列表</el-divider>
        <el-row>
          <el-col :span="24" class="tr">
            <el-button type="primary" size="mini" @click="addSku">添加SKU</el-button>
          </el-col>
        </el-row>
        <div class="mb-10" v-for="(item, index) in addForm.skus" :key="index">
          <el-form-item label="sku 描述">
            <el-input v-model="item.sku_description" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="单价" :prop="'skus.' + index + '.sku_price'">
            <el-input v-model.number="item.sku_price" size="mini"></el-input>
          </el-form-item>
          <div v-for="(spec, specIndex) in specifications" :key="specIndex">
            <el-form-item :label="spec" :prop="`skus.${index}.${spec}`">
              <el-input v-model="item[spec]" size="mini"></el-input>
            </el-form-item>
          </div>
          <el-row>
            <el-col :span="24" class="tr">
              <el-button type="warning" size="mini" icon="el-icon-delete" @click="delSku(index)">删除</el-button>
            </el-col>
          </el-row>
        </div>
        <el-divider />
        <el-row>
          <el-col :span="24" class="tr sub">
            <el-button type="primary" size="mini" @click="handelSubForm('addForm')">提交</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  name: 'ProductAddDrawer',
  props: {
    drawer: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueUeditorWrap
  },
  watch: {
    'addForm.skus': {
      handler (newVal) {
        this.updateSkuRules(newVal)
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      addForm: {
        title: '',
        type: 0,
        image: '',
        on_sale: 0,
        description: '',
        skus: [],
        file: null
      },
      rules: {
        title: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择品类', trigger: 'blur' },
        ]
      },
      specifications: [],
      tagInputVisible: false,
      tagInputValue: '',
      myConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 250,
        initialFrameWidth: "100%",
        serverUrl: this.$store.state.serverUrl,
        zIndex: 9999,
        toolbars: [
          [
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "autotypeset",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "paragraph",
            "fontfamily",
            "fontsize",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "indent",
            "|",
            "imageleft",
            "imageright",
            "imagecenter",
            "simpleupload",
            "preview",
          ],
        ],
      }
    }
  },
  methods: {
    triggerFileInput () {
      this.$refs.skuFileInput.click()
    },
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        if (!file.type.startsWith('image/')) {
          this.$message.error('只能选择图片')
          return
        }
        this.addForm.image = file.name
        this.addForm.file = file
      }
    },
    updateSkuRules (skus) {
      const newSkuRules = {};
      skus.forEach((sku, index) => {
        newSkuRules[`skus.${index}.sku_title`] = [
          { required: true, message: '请输入 SKU 名称', trigger: 'blur' }
        ];
        newSkuRules[`skus.${index}.sku_price`] = [
          { required: true, message: '请输入单价', trigger: 'blur' },
          { type: 'number', message: '单价必须是数字', trigger: 'blur' }
        ];
        // 遍历 specifications 动态添加规则
        this.specifications.forEach((spec) => {
          newSkuRules[`skus.${index}.${spec}`] = [
            { required: true, message: `请输入 ${spec}`, trigger: 'blur' }
          ];
        });
      })
      this.rules = {
        title: this.rules.title,
        type: this.rules.type,
        ...newSkuRules
      };
    },
    handleClose () {
      this.clearDrawerData()
      this.$emit('handleClose', false)
    },
    addSku () {
      this.addForm.skus.push({ sku_description: '', sku_price: 0 })
      console.log(this.addForm)
    },
    delSku (index) {
      this.addForm.skus.splice(index, 1)
      this.updateSkuRules(this.addForm.skus)
    },
    handleTagClose (tag) {
      this.specifications.splice(this.specifications.indexOf(tag), 1);
    },
    handleTagInputConfirm () {
      let inputValue = this.tagInputValue
      if (inputValue) {
        this.specifications.push(inputValue)
      }
      this.tagInputVisible = false
      this.tagInputValue = ''
    },
    showTagInput () {
      this.tagInputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      })
    },
    handelSubForm (formName) {
      if (this.specifications.length === 0) {
        return this.$message.error('请添加产品规格')
      }

      if (this.addForm.skus.length === 0) {
        return this.$message.error('请添加产品sku')
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData()
          for (let key in this.addForm) {
            if (key === 'skus') {
              this.addForm[key].forEach((sku, index) => {
                for (let skuKey in sku) {
                  formData.append(`skus[${index}][${skuKey}]`, sku[skuKey]);
                }
              })
            } else {
              formData.append(key, this.addForm[key])
            }
          }
          this.specifications.forEach((specification, index) => {
            formData.append(`specifications[${index}]`, specification);
          })
          this.$axios.post('/api/admin/qyh_products', formData, { loadingClose: true })
            .then((res) => {
              const { data } = res
              if (data.code === 0) {
                this.$message.success(data.msg)
                this.handleClose()
                this.$emit('refreshData')
              }
            })
        }
      })
    },
    clearDrawerData () {
      this.addForm.title = ''
      this.addForm.type = 0
      this.addForm.image = ''
      this.addForm.on_sale = 0
      this.addForm.description = ''
      this.addForm.skus = []
      this.addForm.file = null
      this.specifications = []
      this.tagInputVisible = false
      this.tagInputValue = ''
    }
  }
}
</script>
<style lang="stylus" scoped>
.el-drawer__wrapper >>> .el-drawer__body {
  overflow-y: auto
}
.el-form-item {
  margin-bottom: .2rem;
}
.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner, .el-select {
  width 100%;
}
.el-form-item__content .el-input-group {
  vertical-align: middle;
}
.tr {
  text-align: right;
}
.mb-10 {
  margin-bottom: .2rem;
}
.el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner {
  color: #FFF;
  background-color: #409EFF;
  border: 1px solid #409eff;
  border-bottom: 0;
}
.sub {
  padding-bottom: .2rem;
}
.ueditor >>> .el-form-item__content {
  line-height: normal;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.input-new-tag {
  width: 90px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/pages/all_products/common/ProductAddDrawer.vue